import { useState } from 'react'
import { Country } from 'react-phone-number-input'

import style from './phone-verification.module.scss'
import { CustomCountries } from './phone-verification.types'
import closeIcon from '../../assets/images/close-dark.svg'

interface CountrySelectModalProps {
  isOpen: boolean
  countries: CustomCountries
  onClose: () => void
  onSelect: (country: Country) => void
  selectedCountry?: Country
}

export const CountrySelectModal = ({
  isOpen,
  countries,
  onClose,
  onSelect,
  selectedCountry,
}: CountrySelectModalProps) => {
  const [searchTerm, setSearchTerm] = useState('')

  const filteredCountries = countries.filter(
    country =>
      country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      country.dialCode.includes(searchTerm),
  )

  if (!isOpen) return null

  return (
    <div>
      <div className={style.header} style={{ paddingLeft: 0, paddingRight: 0 }}>
        <h3>Select Country</h3>
        <button onClick={onClose} className={style.closeButton}>
          <img src={closeIcon} alt="close" />
        </button>
      </div>
      <div style={{ marginBottom: '1rem', borderBottom: '1px solid #ddd' }}>
        <input
          type="text"
          placeholder="Search Countries"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            height: '50px',
            padding: '12px 15px',
            border: '1.48px solid #ddd',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            marginBottom: '16px',
          }}
        />
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {filteredCountries.map(country => (
            <div
              key={country.code}
              onClick={() => {
                onSelect(country.code)
                onClose()
              }}
              className={`${style.countryItem} ${
                selectedCountry === country.code ? style.selected : ''
              }`}
            >
              <span className={style.countryFlag}>{country.flag}</span>
              <div className={style.countryInfo}>
                <div className={style.countryName}>{country.name}</div>
                <div className={style.countryDialCode}>{country.dialCode}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
